<template>
  <modal :open="internalOpen" :width="1000">
    <template #header>
      <modal-header variant="cross" :saving="loading" @cancel="closeModal()">
        <h1>{{ $t('pages.campaigns.candidateList.modal.update.title') }}</h1>
      </modal-header>
    </template>
    <div class="mt-8">
      <div class="text-left mb-8">
        <p>
          <span class="text-gray-500">
            {{ $t('pages.campaigns.candidateList.modal.update.body1') }}
          </span>
          <br>
        </p>
        <p>&nbsp;</p>
        <p style="margin-top: 10px; font-weight: bold;">
          <span class="text-gray-500">
            {{ $t('pages.campaigns.candidateList.modal.update.bodyHint') }}
          </span>
        </p>
        <p style="margin-top: 10px">
          <span class="text-gray-500">
            {{ $t('pages.campaigns.candidateList.modal.update.body2') }}
          </span>
        </p>
        <p>
          <span class="text-gray-500">
            {{ $t('pages.campaigns.candidateList.modal.update.body3') }}
          </span>
        </p>
        <p>
          <span class="text-gray-500">
            {{ $t('pages.campaigns.candidateList.modal.update.body4') }}
          </span>
        </p>
      </div>
      <div class="w-full text-center flex justify-center gap-4">
        <custom-button
          variant="secondary"
          @click="abort"
        >
          {{ $t('abort') }}
        </custom-button>
        <custom-button
          variant="primary"
          :busy="loading"
          @click="save"
        >
          {{ $t('pages.campaigns.candidateList.modal.update.buttonText') }}
        </custom-button>
      </div>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import CustomButton from '@utils/CustomButton.vue';
import { useNotify } from '@utils/notifications';
import { useFetchAction } from '@hooks/fetch';
import type { CampaignGroup } from '@/entities/Entities';

interface Props {
  open: boolean;
  campaignGroup?: CampaignGroup;
}

const emit = defineEmits(['update:open', 'saved']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

const { t } = useI18n();
const notify = useNotify();

function closeModal() {
  internalOpen.value = false;
}

function abort() {
  closeModal();
}

const [exec, { loading }] = useFetchAction();

async function save() {
  if (!props.campaignGroup?.['@id']) {
    notify?.({
      variant: 'error',
      title: t('pages.campaigns.driverList.modal.new.saveError'),
    });
    return;
  }

  try {
    await exec('/campaign_candidates/update', {
      method: 'POST',
      body: {
        campaignGroup: props.campaignGroup?.['@id'],
      },
    });

    notify?.({
      variant: 'success',
      title: t('pages.campaigns.driverList.modal.new.saveSuccess'),
    });

    emit('saved');
    closeModal();
  } catch (e) {
    notify?.({
      variant: 'error',
      title: t('pages.campaigns.driverList.modal.new.saveError'),
    });
    closeModal();
  }
}
</script>

<style lang="scss" scoped></style>
